/**
 * Teams Module — Module Configuration
 *
 * Manages teams and their membership for team-based row scoping.
 * Accessed via the Settings navigation group.
 *
 * @see docs/RBAC-API.md — Teams section
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const teamsModule: AppModule = {
    id: 'teams',

    navigation: {
        label: 'Teams',
        icon: 'users-round',
        path: '/teams',
        order: 5,
        moduleKey: 'settings.users',
        showInSidebar: false, // Accessed via Settings navigation group
        pages: [
            {
                label: 'All Teams',
                path: '/teams',
                icon: 'users-round',
            },
            {
                label: 'Add Team',
                path: '/teams/create',
                icon: 'user-round-plus',
            },
        ],
    },

    routes,
}

export default teamsModule
